const images = import.meta.glob('../../images/**/*', { eager: true })

export function getImageUrl(path) {
  log(path)
  const mod = images[`../../images/${path}`]
  if (!mod) throw new Error(`No image available for ${path}`)
  return mod.default
}
